<template>
  <div>
<!--    <div class="al-button" @click="sendReminderAll">Send Reminder All</div>-->

    <div class="rewards-table">
      <div class="rt-heading">
        <div class="rt-h-col">Campaign</div>
        <div class="rt-h-col">Reward Name</div>
        <div class="rt-h-col">Customer Name</div>
        <div class="rt-h-col">Earned Date</div>
        <div class="rt-h-col">Reward Code</div>
        <div class="rt-h-col">Expire Date</div>
        <div class="rt-h-col">Action</div>
      </div>
      <div class="rt-body" v-if="result.length > 0" v-for="(item, index) in result" :key="index">
        <div class="rt-b-col"><h4>{{ item.post.name }}</h4></div>
        <div class="rt-b-col"><h4>{{ item.prize.name }}</h4></div>
        <div class="rt-b-col"><h4>{{ item.email }}</h4></div>
        <div class="rt-b-col">{{ item.earned_date ? item.earned_date : 'No record' }}</div>
        <div class="rt-b-col">{{ item.prize.code }}</div>
        <div class="rt-b-col">{{ item.expire_date ? expireDate(item.expire_date) : 'No record' }}</div>
        <div class="rt-b-col"><div class="al-button" @click="sendReminder(item.code)">Send Reminder</div></div>
      </div>
      <send-reminder-popup v-if="showPopup" :code="selectedCode" :cancel="cancelReminder" :updated="SendReminderResult" />
    </div>
  </div>
</template>

<script>
import SendReminderPopup from './SendReminderPopup.vue'
import moment from 'moment'
export default {
  components: {
    SendReminderPopup,
    moment
  },
  data () {
    return {
      showPopup: false,
      result: [],
      selectedCode: null
    }
  },
  mounted () {
    this.getRewards()
  },
  methods: {
    expireDate (str) {
      return moment(str).format('MM/DD/YYYY')
    },
    getRewards () {
      const payload = {
        type: 'expires'
      }
      this.$store.dispatch('getRewardsList', payload)
        .then((response) => {
          console.log('success', response)
          this.result = response.data.data
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    sendReminder (code) {
      this.selectedCode = code
      this.showPopup = true
    },
    sendReminderAll () {
      this.$store.dispatch('sendReminderAll')
        .then(response => {
          console.log(response)
        })
        .catch(e => {
          console.log(e)
        })
    },
    cancelReminder () {
      this.showPopup = false
      this.selectedCode = null
    },

    openConfirm (accept) {
      this.$vs.dialog({
        type:'alert',
        color: 'danger',
        title: 'Confirm',
        text: 'Email has been sent.',
        accept,
        acceptText: 'Ok'
      })
    },
    SendReminderResult (code) {
      this.showPopup = false
      const payload = {
        code
      }
      this.$store.dispatch('sendReminder', payload)
        .then(response => {
          console.log(response)
          this.openConfirm(() => {})
        })
        .catch(e => {
          console.log(e)
        })
    }
  }
}
</script>
